import browserUpdate from 'browser-update';

const CONFIG = {
    test: false,
    required: {
        e: -2,
        f: -2,
        o: -2,
        s: -2,
        c: -2,
    },
    no_permanent_hide: true,
};

export function initBrowserUpdate() {
    browserUpdate(CONFIG);
}
